import { z } from "zod";
import { TObjectBase } from "../../base";
import { TTranslationData } from "../../common/translation";
import { TReadAccess } from "../../common/readAccess";

export type IRawCompanyCollection = z.infer<typeof TRawCompanyCollection>;
export const TRawCompanyCollection = z
  .object({
    allProperties: z.optional(z.boolean()),
    connections: z.optional(
      z.object({
        deviations: z.optional(z.boolean()),
        routines: z.optional(z.boolean()),
        propertyFiles: z.optional(z.boolean()),
      })
    ),

    customFieldsOrder: z.array(z.string()).default([]),
    previewFields: z.array(z.string()).default([]),

    name: TTranslationData.optional(),

    selectedProperties: z.optional(z.array(z.string())),
    standardLangCode: z.optional(z.string()),

    readAccess: TReadAccess,
    requiredWriteAccess: z.optional(TReadAccess),
  })
  .extend(TObjectBase.shape);

export const TRawCompanyCollectionItem = z
  .object({
    name: z.string(),
  })
  .extend(TObjectBase.shape);
export type IRawCompanyCollectionItem = z.infer<
  typeof TRawCompanyCollectionItem
>;
